import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelect } from "@pankod/refine-core";
import axios from "utils/axios";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@pankod/refine-mui";
import DescriptionIcon from "@mui/icons-material/Description";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ImageIcon from "@mui/icons-material/Image";

import AutoGeneratedInputCmp from "../../components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  record,
  user,
}) {
  const [decoFiles, setDecoFiles] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const { options: products } = useSelect({
    resource: "products",
    optionLabel: "name",
    optionValue: "id",
  });

  useEffect(() => {
    if (products) {
      setValue("product", Number(localStorage.getItem("prod")));
      //   setTimeout(() => {
      //     localStorage.removeItem("prod");
      //   });
    }
  }, [setValue, products]);

  // precompile known fields
  useEffect(() => {
    if (record) {
      setValue("full_name", record.first_name + " " + record.last_name);
      setValue("business_name", record.company);
      setValue("fiscal_code", record?.vat || user.vat);
      setValue("address1", record.address);
      setValue("city", record.city);
      setValue("zip_code", record.zip_code);
      setValue("phone", record.phone);
      setValue("email", record.email);
      // if we can edit this we set the id
      if (record.municipality) {
        if (
          user?.role?.name === "Muincipality" ||
          user?.role?.name === "Admin"
        ) {
          setValue("municipality", record.municipality.id);
          setValue("user_category", record.user_category.id);
        } else {
          setValue("municipality", record.municipality.name);
          setValue("user_category", record.user_category.name);
        }
      }
      setLoaded(true);
    }
  }, [user, getValues, record, setValue]);

  useEffect(() => {
    if (record && record.files)
      // console.log("CARICO", record.image);
      setDecoFiles(record.files);
  }, [record]);

  const registryFields = [
    {
      label: "Il sottoscritto",
      name: "full_name",
      type: "text",
      placeholder: "Nome e cognome",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Nato il",
      name: "date_of_birth",
      type: "date",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "a",
      name: "birthplace",
      type: "text",
      placeholder: "Città di nascita",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "e residente in",
      name: "city",
      placeholder: "Città di residenza",
      type: "text",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "via",
      name: "address1",
      placeholder: "Indirizzo",
      type: "text",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "codice fiscale",
      name: "fiscal_code",
      placeholder: "CF",
      type: "text",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "nella qualità di titolare/leg. rappr. della Ditta",
      name: "business_name",
      placeholder: "Ragione sociale",
      type: "text",
      require: true,
      md: 12,
      lg: 12,
      style: { marginBottom: "20px" },
    },
  ];

  const fields = [
    {
      label: "PREMESSA",
      name: "premise",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "CENNI E RICERCA STORICA",
      name: "history",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "a) descrizione generale",
      name: "description",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "b) area di produzione",
      name: "production_area",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label:
        "c) metodo di coltivazione / produzione / preparazione (compresi ingredienti e quantità)",
      name: "production_method",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "d) impieghi / proprietà e caratteristiche note del prodotto",
      name: "properties",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "e) consumo / commercializzazione del prodotto",
      name: "commercialization",
      required: true,
      type: "text",
      lines: 3,
      md: 12,
      style: { marginBottom: "20px" },
    },
  ];

  const addressFields = [
    {
      label: "con sede in",
      name: "sede_city",
      type: "text",
      placeholder: "Città",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Via",
      name: "sede_address",
      type: "text",
      placeholder: "Indirizzo",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "codice fiscale",
      name: "sede_fiscal_code",
      placeholder: "CF",
      type: "text",
      require: true,
      md: 6,
      lg: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "premesso che: la propria ditta produce",
      name: "product",
      required: true,
      type: "select",
      options: products,
      disabled: true,
      md: 12,
      lg: 12,
      style: { marginBottom: "20px" },
    },
  ];

  const removeDocument = async (docId) => {
    // doc.id
    // send axios.delete
    try {
      await axios.delete(`/api/upload/files/${docId}`);

      toast.success("documento eliminato");
      const oldFiles = [...decoFiles];
      const newFiles = oldFiles.filter((file) => file.id !== docId);
      setDecoFiles([...newFiles]);
      setValue("files", [...newFiles.map((f) => f.id)]);
    } catch (error) {
      toast.error("Si è verificato un errore");
    }
  };

  if (!products || products.length === 0) return null;

  return (
    <Grid item xs={12}>
      {!loaded && (
        <Grid
          container
          spacing={2}
          style={{ padding: "30px" }}
          justifyContent="center"
        >
          <Typography variant="h4">Caricamento...</Typography>
        </Grid>
      )}
      {loaded && (
        <Grid container spacing={2} style={{ padding: "30px" }}>
          <TextField
            {...register("status")}
            hidden
            required={true}
            defaultValue="pending"
            type="text"
            style={{ height: "0", display: "none" }}
          />
          <TextField
            {...register("product")}
            hidden
            required={true}
            type="text"
            style={{ height: "0", display: "none" }}
          />
          {registryFields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                {...field}
                register={register}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
              />
            );
          })}
          <Stack
            gap={2}
            direction="column"
            sx={{ marginLeft: "16px", width: "100%" }}
          >
            <Typography variant="body1">avente qualifica di: </Typography>

            <FormControlLabel
              label="Imprenditore agricolo"
              control={
                <Checkbox
                  {...register("is_imprenditore_agricolo")}
                  name="is_imprenditore_agricolo"
                />
              }
            />
            <FormControlLabel
              label="Artigiano"
              control={
                <Checkbox {...register("is_artigiano")} name="is_artigiano" />
              }
            />
            <FormControlLabel
              label="Commerciante al dettaglio"
              control={
                <Checkbox
                  {...register("is_commerciante")}
                  name="is_commerciante"
                />
              }
            />
            <FormControlLabel
              label="esercente attività di somministrazione di alimenti e bevande"
              control={
                <Checkbox {...register("is_esercente")} name="is_esercente" />
              }
            />
            <div>
              <FormControlLabel
                label="Altro"
                control={<Checkbox {...register("is_other")} name="is_other" />}
              />
              <TextField
                type="text"
                {...register("is_other_text")}
                name="is_other_text"
                variant="outlined"
                sx={{ padding: "8px 12px" }}
              />
            </div>
          </Stack>
          {addressFields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                {...field}
                register={register}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
              />
            );
          })}

          <Stack
            gap={2}
            direction="column"
            sx={{ marginLeft: "16px", width: "100%" }}
          >
            <FormControlLabel
              label="il suddetto prodotto è già iscritto nel registro comunale De.Co., oppure"
              control={
                <Checkbox {...register("ask_check_1")} name="ask_check_1" />
              }
            />
            <FormControlLabel
              label="per le sue prerogative e il suo stretto legame con il territorio, è meritevole di ottenere la De.Co"
              control={
                <Checkbox {...register("ask_check_2")} name="ask_check_2" />
              }
            />
            <h3>CHIEDE</h3>

            <FormControlLabel
              label="di essere iscritto nel registro comunale De.Co. per il suddetto prodotto, oppure"
              control={
                <Checkbox
                  {...register("is_already_registered")}
                  name="is_already_registered"
                />
              }
            />
            <FormControlLabel
              label="lʼiscrizione nel registro De.Co. del suddetto prodotto e del proprio nominativo con possibilità di utilizzare il relativo logo"
              control={
                <Checkbox
                  {...register("is_deserving_deco")}
                  name="is_deserving_deco"
                />
              }
            />

            <h3>A tal fine, dichiara, sotto la propria responsabilità:</h3>
            <FormControlLabel
              label="di impegnarsi a rispettare, in caso di attribuzione della De.Co., le disposizioni dello specifico regolamento comunale, il disciplinare di produzione
            o le indicazioni contenute nella scheda descrittiva del prodotto, approvati dal Comune"
              control={
                <Checkbox
                  {...register("responsibility_check_1")}
                  name="responsibility_check_1"
                />
              }
            />
            <FormControlLabel
              label="che nella produzione, trasformazione, preparazione, commercializzazione ed etichettatura del prodotto sono rispettate tutte le norme vigenti"
              control={
                <Checkbox
                  {...register("responsibility_check_2")}
                  name="responsibility_check_2"
                />
              }
            />
            <FormControlLabel
              label="che non sono impiegati prodotti transgenici, ovvero contenenti organismi geneticamente modificati (O.G.M.)"
              control={
                <Checkbox
                  {...register("responsibility_check_3")}
                  name="responsibility_check_3"
                />
              }
            />
            <FormControlLabel
              label="di accettare i controlli che potranno essere disposti alla sua azienda in ordine alle corrette modalità di preparazione del prodotto De.C.O."
              control={
                <Checkbox
                  {...register("responsibility_check_4")}
                  name="responsibility_check_4"
                />
              }
            />
            <h3>SCHEDA DESCRITTIVA DEL PRODOTTO</h3>
          </Stack>

          {fields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                {...field}
                register={register}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
              />
            );
          })}
          <Stack gap={2} direction="column" sx={{ marginLeft: "16px" }}>
            <Typography variant="body1">F) controlli e sanzioni</Typography>
            <Typography variant="body2">
              Aggiungi file es. Autocontrollo igienico-sanitario previsto dai
              Reg. (UE) 852/853 del 2004. Rintracciabilità secondo il Reg. (UE)
              178/2002. Uso improprio di logo e denominazione
            </Typography>
            {decoFiles.map((doc) => {
              return (
                <div key={doc.id}>
                  {doc.mime.includes("image") ? (
                    <Stack gap={2} direction="row" alignItems="center">
                      <ImageIcon />
                      <Typography variant="body1">{doc.name}</Typography>
                      <DeleteForeverIcon
                        onClick={() => removeDocument(doc.id)}
                        sx={{ color: "red", cursor: "pointer" }}
                      />
                    </Stack>
                  ) : (
                    <Stack gap={2} direction="row">
                      <DescriptionIcon />
                      <Typography variant="body1">{doc.name}</Typography>
                    </Stack>
                  )}
                </div>
              );
            })}
            <SimpleUploadZone
              label="CARICA DOCUMENTO"
              repeat={true}
              onChange={async (file) => {
                try {
                  const documents = getValues("files") || [];
                  console.log("files", documents);
                  setValue("files", [...documents, file.id]);
                  setDecoFiles((f) => [...f, file]);
                  toast.success("Documento caricato con successo");
                } catch (error) {
                  toast.error("Documento non caricato");
                  console.log(error);
                }
              }}
            />
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}
